// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".chips-module__container--1v38f{padding:2px 12px;display:inline-block;-webkit-border-radius:20px;-moz-border-radius:20px;border-radius:20px;font-weight:400;font-size:14px;line-height:21px;letter-spacing:0}.chips-module__information--30_L9{background-color:#f3f5f7}.chips-module__warning--3nqoa{background-color:#da345e;color:#fff}.chips-module__success--3eiaz{background-color:#02b875;color:#fff}.chips-module__future--1gJ-9{background-color:#8b1aa8;color:#fff}.chips-module__primary--3kKsN{background-color:#5283d5;color:#fff}\n", ""]);
// Exports
exports.locals = {
	"container": "chips-module__container--1v38f",
	"information": "chips-module__information--30_L9",
	"warning": "chips-module__warning--3nqoa",
	"success": "chips-module__success--3eiaz",
	"future": "chips-module__future--1gJ-9",
	"primary": "chips-module__primary--3kKsN"
};
module.exports = exports;
